import { render, staticRenderFns } from "./AppointmentCreated.vue?vue&type=template&id=18899732"
import script from "./AppointmentCreated.vue?vue&type=script&lang=js"
export * from "./AppointmentCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports